const objectToArray = (data) => {
    let array = [];
    for (const [, value] of Object.entries(data)) {
        array.push(value);
    }
    return array;
};

export default objectToArray;
